import { useI18n } from '../i18n';
import { VIRTUAL_IMG } from '../constants';
import { Reveal } from './Reveal';

/** Foto Virtual / Augmented Reality feature: image + copy, split layout. */
export const VirtualPhoto = () => {
  const { t } = useI18n();
  return (
    <section className="feature sec" id="foto">
      <div className="wrap">
        <div className="row">
          <Reveal className="feature-media">
            <img src={VIRTUAL_IMG} alt={t.virtual.title} />
          </Reveal>
          <Reveal delay={1}>
            <span className="kicker">{t.virtual.kicker}</span>
            <h2>{t.virtual.title}</h2>
            <p>{t.virtual.text}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
